import { color, spacing, media } from "@universityofmaryland/web-token-library";
import "../../typography/font-face/index.js";
import "../../typography/campaign.js";
import "../../typography/elements.js";
import { min } from "../../typography/sans.js";
import "../../typography/serif.js";
import "../../typography/stats.js";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/postcss/lib/postcss.js";
import "../../node_modules/postcss-js/index.js";
import "../../node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
const classNamePrefix = "umd-action-button";
const { className: _, ...sansMinStyles } = min;
const fullScreen = objectWithClassName({
  className: `${classNamePrefix}-full-screen`,
  ...sansMinStyles,
  position: "absolute",
  top: "0",
  right: "0",
  color: `${color.white}`,
  textTransform: "uppercase",
  fontWeight: "700",
  padding: `${spacing.min}`,
  display: `flex`,
  alignItems: `center`,
  backgroundColor: `rgba(0, 0, 0, 0.5)`,
  transition: `background-color 0.3s`,
  [`&:hover, &:focus`]: {
    backgroundColor: `rgba(0, 0, 0, 1)`
  },
  "& > span": {
    display: `block`,
    height: `12px`,
    width: `1px`,
    margin: `0 ${spacing.min}`,
    backgroundColor: `${color.gray.mediumAA}`
  }
});
const videoState = objectWithClassName({
  className: `${classNamePrefix}-video-state`,
  position: "absolute",
  bottom: "0",
  right: "0",
  width: "40px",
  height: "40px",
  zIndex: "9999",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(0, 0, 0, 0.7)",
  transition: `background-color 0.3s`,
  [`@media (${media.queries.tablet.min})`]: {
    width: "44px",
    height: "44px"
  },
  [`&:hover, &:focus`]: {
    backgroundColor: `rgba(0, 0, 0, 1)`
  },
  "& > svg": {
    fill: `${color.white}`,
    width: "20px"
  }
});
export {
  fullScreen,
  videoState
};
//# sourceMappingURL=button.js.map
